import { render, staticRenderFns } from "./digitalHuman_customizeSound.vue?vue&type=template&id=cdfb426c&scoped=true"
import script from "./digitalHuman_customizeSound.vue?vue&type=script&setup=true&lang=js"
export * from "./digitalHuman_customizeSound.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdfb426c",
  null
  
)

export default component.exports